<template>
  <main v-if="video" class="watch">
    <div v-if="isDesktop" class="areas area-minimize">
      <i @click="showMinimize(video)" />
      <span>Свернуть в окно</span>
    </div>
    <!-- <div class="areas area-home">
      <i @click="$router.go(-1)" />
      <span>Вернуться (Esc)</span>
    </div> -->

    <div v-if="turnOff" class="turnoff" />

    <section class="header">
      <!-- <div style="padding: 20px 20px 0;">
        <nuxt-link to="/watch" class="backlink">Каталог аниме</nuxt-link>
      </div> -->

      <article class="film-detail" itemscope itemtype="http://schema.org/Movie">
        <!-- <div class="shadow">
          <img
            :src="videoPoster"
            :alt="'Постер ' + video.title_ru + ' ' + video.year"
            :title="'Смотреть онлайн ' + videoType.name + ' ' + video.title_ru + ' ' + video.year + '.'"
            itemprop="image"
          >
          <h2 itemprop="name">
            {{ video.title_ru }}
          </h2>
        </div> -->

        <section v-if="video.material_data" itemprop="video" itemscope itemtype="http://schema.org/VideoObject" class="film-header nopad">
          <link :href="fullPath" itemprop="url">
          <link
            :href="videoPoster"
            itemprop="thumbnailUrl"
          >
          <meta itemprop="contentUrl" :content="video.iframe_url" />
          <meta :content="video.material_data.rating_mpaa || 'MPAA'" itemprop="contentRating">
          <meta
            :content="video.duration
              ? 'PT' + Math.floor(video.duration / 60 / 60) + 'H' + Math.floor(video.duration / 60 % 60) + 'M' + '04S'
              : 'PT2H52M04S'"
            itemprop="duration"
          >
          <!-- <meta itemprop="dateReleased" :content="video.material_data.updated_at"> -->
          <meta :content="video.created_at" itemprop="uploadDate">
          <meta :content="video.created_at" itemprop="datePublished">
          <meta itemprop="inLanguage" content="ru_RU">
          <meta itemprop="isFamilyFriendly" content="true">
          <meta :content="video.material_data.studios" itemprop="productionCompany">
          <meta :content="video.kinopoisk_id + '.jpg' || 'no-poster.png'" itemprop="thumbnail">
          <meta itemprop="videoQuality" content="HD">

          <!-- <div class="film-meta">
            <h2 class="videotype-name">
              <span v-if="video.title_en" itemprop="alternativeHeadline">
                {{ video.title_en }}
              </span>
            </h2>
            <ul class="tags-list">
              <li v-if="video.year" itemprop="dateCreated">
                <nuxt-link :to="`/watch?type=${video.type}&year=${video.year}`">
                  {{ video.year }}
                </nuxt-link>
              </li>
              <li v-for="country in video.material_data.countries" :key="country">
                <nuxt-link :to="`/watch?type=${video.type}&country=${country}`">
                  {{ country }}
                </nuxt-link>
              </li>
              <li v-for="genre in video.material_data.genres" :key="genre" itemprop="genre">
                <nuxt-link :to="`/watch?type=${video.type}&genre=${genre}`">
                  {{ genre }}
                </nuxt-link>
              </li>
            </ul>
          </div> -->

          <h1 itemprop="name" style="margin-bottom: 24px;">
            «{{ video.title_ru.replace(/[«»]/gi, '') }}» смотреть онлайн
            <span v-if="se && se.s">{{ se.s }} сезон</span>
            <span v-if="se && se.e">{{ se.e }} серия</span>
            <span v-if="se && se.t">{{ se.t }}</span>
          </h1>

          <div class="film-iframe clickadilla-video">
            <div v-show="!loadVideo" class="film-poster">
              <fav-component :fav="video" />
              <div v-if="!isBlock" @click="showTrailers" class="trailers-btn">
                <i class="player"/>
                <strong>Трейлер</strong>
              </div>
              <div>
                <img
                  :src="videoPoster"
                  alt=""
                  class="amb-poster"
                >
              </div>
              <div class="poster">
                <img
                  :src="videoPoster"
                  :alt="`Постер к ${videoType.name.toLowerCase()}у ${video.title_ru} (${video.year})`"
                  itemprop="image"
                >
              </div>
              <div
                v-if="!isBlock"
                @click="setIframe"
                class="load-iframe"
                title="Начать просмотр"
              >
                <i class="load-iframe-icon" />
                <strong v-if="isDesktop">Смотреть онлайн</strong>
                <strong v-else>Смотреть</strong>
              </div>
              <div
                v-else
                @click="showTrailers"
                class="load-iframe"
                title="Начать просмотр"
              >
                <i class="load-iframe-icon" />
                <strong v-if="isDesktop">Смотреть онлайн</strong>
                <strong v-else>Смотреть</strong>
              </div>
            </div>
            <div v-show="!isBlock && !loadVideo && video.kinopoisk_id" class="download-film-link">
              <nuxt-link :to="`/download-anime/${video.kinopoisk_id}`">
                Скачать «{{ video.title_ru.replace(/[«»]/gi, '') }}»
              </nuxt-link>
            </div>
            <div class="film-player">
              <div class="biges">
                <span v-if="video.year === new Date().getFullYear()" class="new-film" title="Премьера этого года">Новинка</span>
                <!-- <span class="tags-source" title="Наилучшее качество 1080р">HD</span> -->
              </div>
              <div v-if="isDesktop" class="turnoff-btn" @click="turnOff = !turnOff">
                <span v-if="!turnOff">Выключить свет</span>
                <span v-else>Включить свет</span>
              </div>
              <div :style="`background-image: url(${videoPoster})`" class="blur-poster" />
              <iframe
                ref="iframe"
                :title="`Смотреть онлайн ${video.title_ru}`"
                allowfullscreen
                class="iframe"
              />
              <!-- <div v-if="video.material_data.screenshots && video.material_data.screenshots.length && !loadVideo" class="screenshots">
                <img
                  v-if="video.material_data.screenshots[0]"
                  :data-src="video.material_data.screenshots[0]"
                  :alt="`Кадр 1 ${video.title_ru}`"
                  src="/static_files/no-poster.png"
                  class="lazyload"
                >
                <img
                  v-if="video.material_data.screenshots[1]"
                  :data-src="video.material_data.screenshots[1]"
                  :alt="`Кадр 2 ${video.title_ru}`"
                  src="/static_files/no-poster.png"
                  class="lazyload"
                >
              </div> -->
            </div>
          </div>

          <div v-if="!isBlock && loadVideo && vers.length" class="all-version">
            <!-- <h4>
              Все доступные варианты
            </h4> -->
            <div style="margin-bottom:5px;">
              <div v-if="!isDesktop && video.type === 'anime-serial'" style="display:inline-block">
                <button @click="switchSE('-')" class="dbtn">Пред.</button>
                <button @click="switchSE('+')" class="dbtn">След.</button>
                <button @click="rememberSE" class="dbtn blue">
                  Запомнить
                </button>
              </div>
              <label>
                <strong>Озвучка</strong>
                <select v-model="eventTranslation" @change="changeTranslation">
                  <option
                    v-for="(t, i) in vers"
                    :key="`film-translation-${t.id}`"
                    :value="i"
                  >
                    {{ t.title }}
                  </option>
                </select>
              </label>
              <label v-if="('' + eventTranslation) && vers[eventTranslation].seasons">
                <strong>сезон</strong>
                <select v-model="eventSeason">
                  <option
                    v-for="(s, i) in vers[eventTranslation].seasons"
                    :key="`film-season-${i}`"
                    :value="i"
                  >
                    {{ i }}
                  </option>
                </select>
              </label>
              <label v-if="eventSeason">
                <strong>эпизод</strong>
                <select v-model="eventEpisode" @change="setSE">
                  <option
                    v-for="(e, i) in vers[eventTranslation].seasons[eventSeason].episodes"
                    :key="`film-episode-${i}`"
                    :value="i"
                  >
                    {{ i }}
                  </option>
                </select>
              </label>
              <div v-if="isDesktop && video.type === 'anime-serial'" style="display:inline-block">
                <button @click="switchSE('-')" class="dbtn">Пред.</button>
                <button @click="switchSE('+')" class="dbtn">След.</button>
                <button @click="rememberSE" class="dbtn blue">
                  Запомнить серию
                </button>
              </div>
              <button
                v-if="!user || (user.group != 77 && user.group != 777)"
                @click="showPremiumComponent = !showPremiumComponent"
                class="dbtn orange"
              >
                Убрать рекламу
              </button>
              <nuxt-link
                v-if="video.kinopoisk_id"
                :to="`/download-anime/${video.kinopoisk_id}`"
                tag="button"
                class="dbtn"
              >
                Скачать
              </nuxt-link>
              <button v-if="!vkList.count" @click="onVK" class="dbtn">
                Поискать в ВК
              </button>
            </div>
          </div>
          
          <premium-component v-if="showPremiumComponent" style="margin-top:30px;" />

          <div v-if="vkList.items.length" class="on-vk">
            <strong>Найдено {{ vkList.count }}</strong>
            <div class="list">
              <div
                v-for="(item, i) in vkList.items"
                :key="`on-vk-${i}`"
                @click="setIframeVK(item.player)"
                :title="item.title"
                class="item"
              >
                <div class="poster">
                  <img :src="item.image[2].url" alt="">
                </div>
                <i class="player" />
                <div class="meta">
                  <strong>
                    {{ item.title.length > 25 ? `${item.title.slice(0, 25)}...` : item.title }}
                  </strong>
                  <span>Просмотров {{ item.views }}</span>
                </div>
              </div>
            </div>

            <div
              v-if="vkList.items.length < vkList.count"
              @click="onVK(++onVKPage)"
              class="show-more"
            >
              <span>
                Показать еще
              </span>
            </div>
          </div>
        </section>


        <!-- <div class="file-info">
          <ul class="btns">
            <li @click="showNotification = !showNotification" class="btn">
              <span class="btn notification" title="Напоминания">
                <i :class="{'icon-notification': true, 'active': showNotification}" />
              </span>
              <strong>Уведомления</strong>
              <div v-if="showNotification" class="modal-notification">
                <i  @click="showNotification = false" class="close" />
                <p>
                  Подпишитесь на
                  <span> аниме и узнайте первым о выходе новой серии.</span>
                  <nuxt-link to="/subscribe">
                    Подробнее об уведомлениях
                  </nuxt-link>
                </p>
                <a href="https://vk.com/im?sel=-189741703" class="go-to-subscribe">
                  Подписаться
                </a>
              </div>
            </li>
            <li class="btn">
              <fav-component :fav="video" />
              <strong>В списки</strong>
            </li>
            <li v-if="!isBlock" @click="createCinema(video.sh_id || video.wa_id || video.kinopoisk_id)" class="btn">
              <span class="btn" title="Создать комнату">
                <i class="icon-create-stream" />
              </span>
              <strong>Создать комнату</strong>
            </li>
          </ul>
        </div> -->

        <div class="film-menu">
          <ul :style="`width: ${
            140 * (
              video.type === 'anime-serial' && updates.length
                ? 6
                : updates.length || video.type === 'anime-serial'
                  ? 5
                  : 4
            )}px;`">
            <li @click="goToComments">
              Отзывы
            </li>
            <li @click="filmMenu = 'info'" :class="{ active: filmMenu === 'info' }">
              Информация
            </li>
            <li @click="filmMenu = 'screens'" :class="{ active: filmMenu === 'screens' }">
              Кадры
            </li>
            <li @click="showTrailers" :class="{ active: filmMenu === 'videos' }">
              Видео
            </li>
            <li v-if="updates.length" @click="filmMenu = 'updates'" :class="{ active: filmMenu === 'updates' }">
              Выход серий
            </li>
            <li v-if="video.type === 'anime-serial'" @click="filmMenu = 'variants'" :class="{ active: filmMenu === 'variants' }">
              Озвучки
            </li>
          </ul>
        </div>

        <section v-if="updates.length" v-show="filmMenu === 'updates'" class="updates-history nopad">
          <h2>Выход серий</h2>
          <div v-for="item in updates" :key="`updates-${item.date}`">
            <span>{{ item.date | filterDate }}</span>
            <strong>
              <a :href="urlToUpdate(video, item.update)">
                {{ item.update }}
              </a>
            </strong>
          </div>
        </section>

        <section v-show="filmMenu === 'info'" class="film-metadata nopad">
          <section class="film-info">
            <!-- <h2>Об аниме</h2> -->
            <div
              v-if="video.material_data.imdb_rating || video.material_data.kinopoisk_rating"
              class="rating-star"
              itemprop="aggregateRating"
              itemscope
              itemtype="http://schema.org/AggregateRating"
            >
              <meta itemprop="worstRating" content="1">
              <meta itemprop="bestRating" content="10">
              <meta v-if="video.material_data.imdb_rating && video.material_data.kinopoisk_rating" :content="Math.floor((video.material_data.imdb_rating + video.material_data.kinopoisk_rating) / 2)" itemprop="ratingValue">
              <meta v-else :content="Math.floor(video.material_data.imdb_rating + video.material_data.kinopoisk_rating)" itemprop="ratingValue">
              <meta :content="video.material_data.imdb_votes + video.material_data.kinopoisk_votes" itemprop="ratingCount">
              <i
                class="rating-star-bg"
                :title="(video.material_data.imdb_votes + video.material_data.kinopoisk_votes) + ' голосов'"
              >
                <i class="rating-star-filled rating-light" />
              </i>
              <strong v-if="video.material_data.imdb_rating && video.material_data.kinopoisk_rating">
                {{ ((video.material_data.imdb_rating + video.material_data.kinopoisk_rating) / 4).toFixed(1) }}
              </strong>
              <strong v-else-if="video.material_data.kinopoisk_rating">
                {{ (video.material_data.kinopoisk_rating / 2).toFixed(1) }}
              </strong>
              <strong v-else-if="video.material_data.imdb_rating">
                {{ (video.material_data.imdb_rating / 2).toFixed(1) }}
              </strong>
              <strong v-else-if="video.material_data.shikimori_rating">
                {{ (video.material_data.shikimori_rating / 2).toFixed(1) }}
              </strong>
              <span>
                <sub>5</sub>
              </span>
            </div>
            <ul>
              <li v-if="video.year">
                Год выпуска:
                <nuxt-link :to="`/watch?type=${video.type}&year=${video.year}`" v-if="video.year" style="text-transform:capitalize;" itemprop="dateCreated" tag="strong">
                  {{ video.year }}
                </nuxt-link>
              </li>
              <li v-if="video.material_data.genres.length">
                Жанр:
                <nuxt-link
                  v-for="genre in video.material_data.genres"
                  :to="`/watch?type=${video.type}&genre=${genre}`"
                  :key="genre"
                  :data-block-genre="genre.toLowerCase() === 'хентай'"
                  tag="strong"
                  itemprop="genre"
                  style="cursor:pointer;"
                >
                  {{ genre }}
                </nuxt-link>
              </li>
              <li v-if="video.material_data.anime_kind">
                Тип:
                <strong style="text-transform:capitalize;">
                  {{ video.material_data.anime_kind }}
                </strong>
              </li>
              <li v-if="video.material_data.anime_status">
                Статус:
                <strong>
                  <nuxt-link :to="`/watch?status=${video.material_data.anime_status.toLowerCase()}`"
                    :class="{
                      green: video.material_data.anime_status.toLowerCase() === 'ongoing',
                      red: video.material_data.anime_status.toLowerCase() === 'released',
                      orange: video.material_data.anime_status.toLowerCase() === 'anons',
                    }"
                    class="status"
                  >{{
                    video.material_data.anime_status.toLowerCase() === 'ongoing'
                      ? 'Онгоинг'
                      : video.material_data.anime_status.toLowerCase() === 'released'
                        ? 'Завершен'
                        : video.material_data.anime_status.toLowerCase() === 'anons'
                          ? 'Анонс'
                          : '' }}</nuxt-link>
                  c {{ video.material_data.aired_at | filterShortDate }}
                </strong>
              </li>
              <li>
                Эпизодов вышло в эфир:
                <strong v-if="video.material_data.episodes_aired && video.material_data.episodes_aired > 0">
                  {{ video.material_data.episodes_aired }}
                </strong>
                <strong v-if="(video.material_data.episodes_aired && video.material_data.episodes_aired > 0) && video.material_data.episodes_total">
                  из
                </strong>
                <strong v-if="video.material_data.episodes_total">
                  {{ video.material_data.episodes_total }}
                </strong>
              </li>
              <li v-if="video.duration">
                <span v-if="video.type.movie">
                  Продолжительность:
                </span>
                <span v-else>
                  Длительность эпизода:
                </span>
                <strong>
                  <template v-if="Math.floor((video.duration / 60) / 60)">
                    {{ Math.floor((video.duration / 60) / 60) }}ч.
                  </template>
                  <template v-if="Math.floor((video.duration / 60) % 60)">
                    {{ Math.floor((video.duration / 60) % 60) }} мин.
                  </template>
                </strong>
              </li>
              <li v-if="video.material_data.kinopoisk_rating">
                Рейтинг КиноПоиск:
                <strong>{{ ('' + video.material_data.kinopoisk_rating).slice(0, 3) }}</strong>
              </li>
              <li v-if="video.material_data.imdb_rating">
                Рейтинг IMDb:
                <strong>{{ ('' + video.material_data.imdb_rating).slice(0, 1) + (('' + video.material_data.imdb_rating).slice(1) || '.0') }}</strong>
              </li>
              <li v-if="video.material_data.shikimori_rating">
                Рейтинг Shikimori:
                <strong>{{ ('' + video.material_data.shikimori_rating).slice(0, 1) + (('' + video.material_data.shikimori_rating).slice(1) || '.0') }}</strong>
              </li>
              <li v-if="video.material_data.premiere_ru">
                Премьера (РФ):
                <strong>{{ video.material_data.premiere_ru | filterShortDate }}</strong>
              </li>
              <li v-if="video.material_data.premiere_world">
                Премьера (мир):
                <strong>{{ video.material_data.premiere_world | filterShortDate }}</strong>
              </li>
              <li v-if="video.material_data.rating_mpaa">
                PG:
                <strong>{{ video.material_data.rating_mpaa }}</strong>
                <sup v-if="parseInt(video.material_data.rating_mpaa)" :title="`Лицам до ${
                  parseInt(video.material_data.rating_mpaa)
                } лет обязательно присутствие взрослого`">?</sup>
              </li>
              <li v-if="video.material_data.writers && video.material_data.writers.length">
                Авторы:
                <strong>{{ video.material_data.writers.join(', ') }}</strong>
              </li>
              <li v-if="video.material_data.studios && video.material_data.studios.length">
                Студия:
                <strong>{{ video.material_data.studios.join(', ') }}</strong>
              </li>
              <li v-if="video.material_data.other_titles.length">
                Альтернативные названия:
                <button v-if="!altNames" @click="altNames = true" class="dbtn">...</button>
              </li>
              <li v-show="altNames && video.material_data.other_titles_jp.length">
                Название по-японски:
                <strong>{{ video.material_data.other_titles_jp.join(', ') }}</strong>
              </li>
              <li v-show="altNames && video.material_data.other_titles.length">
                Другие варианты названия:
                <ul style="list-style:disc;">
                  <li
                    v-if="video.material_data.anime_license_name"
                    style="margin:10px 0;"
                    itemprop="alternativeHeadline"
                  >
                    - {{ video.material_data.anime_license_name }}
                  </li>
                  <li
                    v-for="ot in video.material_data.other_titles"
                    :key="ot"
                    style="margin:10px 0;"
                    itemprop="alternativeHeadline"
                  >
                    - {{ ot }}
                  </li>
                </ul>
              </li>
            </ul>
          </section>

          <section class="film-description">
            <h2 v-if="video.material_data.description">Сюжет</h2>
            <strong v-if="video.tagline && video.tagline !== '-'">{{ video.tagline }}</strong>
            <p v-if="video.material_data.description" itemprop="description">{{ video.material_data.description.trim() }}</p>
            <p v-if="video.material_data.age" class="age">
              Возрастное ограничение {{ video.material_data.age }}+
            </p>

            <div class="action-buttons">
              <reaction-component
                :item="{ id: video.sh_id, reactions: reactions, owner_id: null }"
                style="display:inline-block;"
              />
              <span @click="goToComments" class="go-to-comments">Комментировать</span>
              <share-component :page="{ link: fullPath, button: false }" />
            </div>
          </section>

          <section class="animegg">
            <h2>
              Персонажи
              <sup v-if="video.sh_id"><nuxt-link :to="`/watch/${video.sh_id.slice(2)}/characters`">Еще</nuxt-link></sup>
            </h2>
            <div v-if="characters.length">
              <ul>
                <li
                  v-for="char in characters"
                  :key="`char-${char.id}`"
                  @click.stop="getCharInfo($event, char.id, char.link)"
                >
                  <div class="poster">
                    <img :src="char.poster" :alt="char.name_en || char.name_en">
                  </div>
                  <div>
                    <strong>{{ char.name_ru }}</strong>
                    <span>{{ char.name_en }}</span>
                    <i class="loader" />
                  </div>
                </li>
              </ul>
              <nuxt-link
                v-if="characters.length"
                :to="`/apps/quiz?type=chars&anime=${video.sh_id}`"
                style="display: block; font-weight: 400; padding: 10px; width: 100%; color: #fff; background-color: #8365bc; text-align: center;"
              >
                &#128293; Игра "Узнай персонажа"
              </nuxt-link>
            </div>
            <i v-else class="loader" />

            <div v-if="charInfo" @click="charInfo = null" class="animegg-info">
              <div onclick="event.stopPropagation()" class="animegg-info-modal">
                <div class="action">
                  <span
                    @click="charInfo = null"
                    style="border:1px solid #555;padding:4px 14px;border-radius:30px;color:#555;"
                  >Закрыть</span>
                </div>
                <header>
                  <img :src="charInfo.poster" :alt="charInfo.name">
                  <div class="animegg-info-body">
                    <h2>{{ charInfo.name }}</h2>
                    <div class="description">
                      <div v-html="charInfo.description.slice(0, charInfo.description.indexOf('<br'))" />
                      <nuxt-link
                        :to="`/characters/${postUrl(charInfo.id, charInfo.name.slice(charInfo.name.indexOf('/') + 1))}`"
                      >
                        Читать подробнее
                      </nuxt-link>
                    </div>
                  </div>
                </header>
                <footer>
                  <div>
                    <h4>Замечен в аниме</h4>
                    <ul>
                      <nuxt-link :to="`/watch/sh${a.id}`" v-for="a in charInfo.anime.slice(0, 3)" :key="`animegg-info-anime-${a.id}`" tag="li">
                        <img :src="a.poster" :alt="a.name_ru">
                        <strong v-if="a.name_ru.length > 50" class="name-ru">{{ a.name_ru.slice(0, 50) }}...</strong>
                        <strong v-else class="name-ru">{{ a.name_ru }}</strong>
                        <span v-if="a.name_en.length > 50" class="name-en">{{ a.name_en.slice(0, 50) }}...</span>
                        <span v-else class="name-en">{{ a.name_en }}</span>
                      </nuxt-link>
                    </ul>
                  </div>
                  <div>
                    <h4>Сэйю</h4>
                    <ul>
                      <li v-for="p in charInfo.seyu.slice(0, 3)" :key="`animegg-info-person-${p.id}`">
                        <img :src="p.poster" :alt="p.name_ru">
                        <strong>{{ p.name_ru }}</strong>
                        <span>{{ p.name_en }}</span>
                      </li>
                    </ul>
                  </div>
                </footer>
              </div>
            </div>
          </section>
        </section>

        <section v-show="filmMenu === 'screens'" class="photos-block nopad">
          <h2>Кадры</h2>
          <header v-if="video.material_data && video.material_data.screenshots && video.material_data.screenshots.length">
            <img
              :data-src="video.material_data.screenshots[0]"
              :alt="`Кадр 3 ${video.title_en}`"
              src="/static_files/no-poster.png"
              class="lazyload"
            >
            <img
              :data-src="video.material_data.screenshots[1]"
              :alt="`Кадр 4 ${video.title_en}`"
              src="/static_files/no-poster.png"
              class="lazyload"
            >
          </header>
          <button v-if="!showPhotos" @click="showPhotos = true" class="dbtn">Показать больше кадров</button>
          <photos-component v-else :obj="{ text: `аниме ${video.title_en ? video.title_en : video.title_ru} ${video.year}`, page: 1 }" />
        </section>

        <section v-show="filmMenu === 'videos'" class="videos-block nopad">
          <h2>
            Видео
            <sup>
              <nuxt-link :to="`/amv`" class="more-arrow-right">
                Еще
              </nuxt-link>
            </sup>
          </h2>
          <button
            v-if="!showVideos"
            @click="showVideos = true"
            class="dbtn"
            style="margin-top:20px;"
          >
            Посмотреть
          </button>
          <amv-component v-else :text="amvText" />
        </section>

        <section v-if="video.type === 'anime-serial'" v-show="filmMenu === 'variants'" class="other-block nopad">
          <h2>Озвучки</h2>
          <div v-if="se" class="video-se">
            <ul v-if="vers.length">
              <li v-for="t in vers" :key="t.id">
                <a :href="`${fullPath}${t.id ? `?t=${t.id}` : ''}${se.s ? `&s=${se.s}` : ''}${se.e ? `&e=${se.e}` : ''}`">
                  {{ video.title_ru }} {{ se.s }} сезон {{ se.e }} серия в озвучке {{ t.title }}
                </a>
              </li>
            </ul>
          </div>
          <div v-else class="video-se">
            <ul v-if="vers.length">
              <li v-for="t in vers" :key="t.id">
                <a :href="`${fullPath}${t.id ? `?t=${t.id}` : ''}`">
                  {{ video.title_ru }} в озвучке {{ t.title }}
                </a>
              </li>
            </ul>
          </div>
        </section>

        <!-- <adSense />

        <div id="adfox_165003177429817706" style="text-align:center;margin:20px 0px;"></div> -->

        <!-- <shopItems :title="video.title_ru" /> -->

        <section v-if="related_comics.length" class="nopad sldr">
          <h3>
            Связные комиксы
          </h3>
          <slider-component :videos="{ items: related_comics, type: 'comics' }" />
        </section>

        <section v-if="parts.length" class="nopad sldr">
          <h3>Смотрите также</h3>
          <slider-component :videos="{ items: parts, type: 'watch' }" />
        </section>

        <section v-if="reviews.length" class="reviews">
          <div class="reviews-header">
            <h3>Рецензии</h3>
          </div>
          <div class="reviews-list">
            <article
              v-for="(review, index) in reviews"
              :key="index"
              :class="{ content: true, green: review.type === '1', red: review.type === '2', gray: review.type === '0' }"
            >
              <header class="review-header">
                <img :data-src="review.user_avatar" :alt="review.user_name + ' avatar'" src="'/no-avatar.svg'" class="lazyload">
                <span>{{ review.user_name }}</span>
                <!-- <time
                  :datetime="new Date(review.date).getFullYear() + '-' + new Date(review.date).getMonth() + '-' + new Date(review.date).getDate()"
                  class="time"
                >
                  {{ review.date | filterShortDate }}
                </time> -->
              </header>
              <h4>
                {{ review.title }}
              </h4>
              <p>
                {{ review.text }}
              </p>
              <footer v-if="review.score > 0">
                <strong>
                  Оценка {{ review.score }} из 10
                </strong>
              </footer>
            </article>
          </div>
          <div class="reviews-side" />
        </section>
      </article>
    </section>


    <client-only>
      <comments-component :id="`watch-${video.sh_id || video.wa_id || video.kinopoisk_id}`" />
    </client-only>

    <section v-if="album">
      <div class="h3">
        <nuxt-link :to="`/music/${video.kinopoisk_id}`">
          Музыка из фильма
        </nuxt-link>
      </div>
      <iframe
        frameborder="0"
        style="margin-top:30px;border:none;width:100%;height:600px;"
        width="100%"
        height="600"
        :src="album"
        :title="`Слушайте саундтреки из ${video.title_ru}`"
      />
    </section>
    <div v-else class="yamusic" />

    <section v-if="related.length" class="nopad sldr">
      <div class="h3">Что еще посмотреть</div>
      <slider-component :videos="{ items: related, type: 'watch' }" />
    </section>
  </main>
  <main v-else>
    <h1>Возникла ошибка. Мы работаем над её устранением.</h1>
  </main>
</template>

<script>
import {
  hydrateOnInteraction,
  hydrateWhenIdle,
  hydrateWhenVisible,
} from 'vue-lazy-hydration'
import { mapState } from 'vuex'

export default {
  components: {
    // adSense: () => import('~/components/adSense.vue'),
    favComponent: hydrateOnInteraction(() => import('~/components/favComponent.vue'), { event: 'click' }),
    reactionComponent: hydrateWhenIdle(() => import('~/components/reactionComponent.vue')),
    shareComponent: () => import('~/components/shareComponent.vue'),
    premiumComponent: hydrateWhenIdle(() => import('~/components/premiumComponent.vue')),
    // shopItems: hydrateWhenVisible(() => import('~/components/shopItems.vue')),
    commentsComponent: hydrateWhenVisible(() => import('~/components/commentsComponent.vue')),
    sliderComponent: hydrateOnInteraction(() => import('~/components/sliderComponent.vue'), { event: 'click' }),
    photosComponent: hydrateWhenIdle(() => import('~/components/photosComponent.vue')),
    amvComponent: hydrateWhenIdle(() => import('~/components/amvComponent.vue'))
  },
  filters: {
    filterShortDate(val) {
      const value = val
      const months = [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октября',
        'ноября',
        'декабря'
      ]
      const day = new Date(value).getDate()
      const month = new Date(value).getMonth()
      const year = new Date(value).getFullYear()
      return `${day} ${months[month]} ${year}`
    },
    filterDate(val) {
      const value = val
      const months = [
        'янв',
        'фев',
        'мар',
        'апр',
        'мая',
        'июн',
        'июл',
        'авг',
        'сен',
        'окт',
        'ноя',
        'дек'
      ]
      const day =
        new Date(value).getDate() >= 10
          ? new Date(value).getDate()
          : '0' + new Date(value).getDate()
      const month = new Date(value).getMonth()
      const year = new Date(value).getFullYear()
      const hour =
        new Date(value).getHours() >= 10
          ? new Date(value).getHours()
          : '0' + new Date(value).getHours()
      const min =
        new Date(value).getMinutes() >= 10
          ? new Date(value).getMinutes()
          : '0' + new Date(value).getMinutes()
      return `${day} ${months[month]} ${year} в ${hour}:${min}`
    }
  },
  head() {
    // console.log('head', this.video)
    if (this.video) {
      const poster = this.videoPoster
      const type = 'Аниме'
      // const year = this.video.year
      let salt = ''

      const se = this.video.type === 'anime-serial' && this.se
        ? `${
          this.se.s ? `сезон ${this.se.s}` : ''
        }${
          this.se.e ? `серия ${this.se.e}` : ''
        }${
          this.se.t ? `озвучка ${this.se.t}` : ''
        }`
        : this.se && this.se.t
          ? `озвучка ${this.se.t}`
          : ''

      if (se) {
        salt = `— смотреть онлайн ${se}`
      } else if (this.video.type === 'anime-serial') {
        salt = '— смотреть онлайн все серии бесплатно'
      } else {
        salt = '— смотреть онлайн бесплатно'
      }

      const title = `${this.video.title_ru}${this.video.title_en ? ' / ' + this.video.title_en : ''}`
      if (this.video.material_data) {
        const desc = this.video.material_data.description
        const lastDot = desc ? desc.slice(0, 300).lastIndexOf('.') : ''
        const iframeUrl =
          this.video.iframe_url
            ? this.video.iframe_url
            : 'https://anime777.ru/promo_video.mp4'
        return {
          title: `${title} ${salt}`,
          link: [
            {
              hid: 'canonical',
              rel: 'canonical',
              href: this.fullPath
            }
          ],
          meta: [
            {
              hid: 'keywords',
              name: 'keywords',
              content: `${title} ${se} смотреть онлайн`
            },
            {
              hid: 'og:title',
              property: 'og:title',
              content: `${title} ${salt}`
            },
            {
              hid: 'og:url',
              property: 'og:url',
              content: this.fullPath
            },
            {
              hid: 'og:tags',
              property: 'og:tags',
              content: `${title} ${se} смотреть онлайн`
            },
            {
              hid: 'description',
              name: 'description',
              content:
                'Смотрите онлайн ' +
                type.toLowerCase() +
                ' ' +
                title +
                se + ' бесплатно на русском. Сюжет, трейлеры, персонажи.'
            },
            {
              hid: 'og:description',
              property: 'og:description',
              content: desc ? desc.slice(0, lastDot + 1) : ''
            },
            {
              hid: 'og:image',
              property: 'og:image',
              content: poster
            },
            {
              hid: 'og:image:thumbnailUrl',
              property: 'og:image:thumbnailUrl',
              content: poster
            },
            {
              hid: 'og:image:url',
              property: 'og:image:url',
              content: poster
            },
            {
              hid: 'og:image:secure_url',
              property: 'og:image:secure_url',
              content: poster
            },
            {
              hid: 'og:type',
              property: 'og:type',
              content: 'video.movie'
            },
            {
              hid: 'og:video',
              property: 'og:video',
              content: iframeUrl
            },
            {
              hid: 'og:video:type',
              property: 'og:video:type',
              content: 'application/x-shockwave-flash'
            },
            {
              hid: 'og:video:secure_url',
              property: 'og:video:secure_url',
              content: iframeUrl
            },
            {
              hid: 'og:video:iframe',
              property: 'og:video:iframe',
              content: iframeUrl
            },
            {
              hid: 'ya:ovs:allow_embed',
              property: 'ya:ovs:allow_embed',
              content: 'true'
            },
            {
              hid: 'ya:ovs:embed_html',
              property: 'ya:ovs:embed_html',
              content: `<iframe src='${iframeUrl}'></iframe>`
            },
            {
              hid: 'og:video:width',
              property: 'og:video:width',
              content: '1280'
            },
            {
              hid: 'og:video:height',
              property: 'og:video:height',
              content: '720 '
            },
            {
              hid: 'video:duration',
              property: 'video:duration',
              content: this.video.duration ? this.video.duration : '7020'
            },
            {
              hid: 'ya:ovs:poster',
              property: 'ya:ovs:poster',
              content: poster
            },
            {
              hid: 'ya:ovs:rating',
              property: 'ya:ovs:rating',
              content: this.video.material_data.imdb_rating
                ? Math.floor(this.video.material_data.imdb_rating)
                : Math.floor(this.video.material_data.kinopoisk_rating)
            },
            {
              hid: 'ya:ovs:likes',
              property: 'ya:ovs:likes',
              content: this.video.material_data
                ? this.video.material_data.imdb_votes
                : '0'
            },
            {
              hid: 'ya:ovs:adult',
              property: 'ya:ovs:adult',
              content: this.video.pornolab_id ? 'true' : 'false'
            },
            {
              hid: 'ya:ovs:upload_date',
              property: 'ya:ovs:upload_date',
              content: this.video.created_at
            },
            {
              hid: 'ya:ovs:available_platform_desktop',
              property: 'ya:ovs:available_platform',
              content: 'Desktop'
            },
            {
              hid: 'ya:ovs:available_platform_mobile',
              property: 'ya:ovs:available_platform',
              content: 'Mobile'
            },
            {
              hid: 'ya:ovs:original_name',
              property: 'ya:ovs:original_name',
              content: this.video.title_en || this.video.title_ru
            },
            {
              hid: 'video:release_date',
              property: 'video:release_date',
              content: this.video.created_at
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: `${title} ${salt}`
            },
            {
              hid: 'twitter:description',
              property: 'twitter:description',
              content: desc ? desc.slice(0, lastDot + 1) : ''
            },
            {
              hid: 'twitter:image',
              property: 'twitter:image',
              content: poster
            }
          ]
        }
      } else {
        return {
          title: `${type} ${title} ${salt}`,
          link: [
            {
              hid: 'canonical',
              rel: 'canonical',
              href: this.fullPath
            }
          ],
          meta: [
            {
              hid: 'keywords',
              name: 'keywords',
              content: 'смотреть онлайн, ' + title
            },
            {
              hid: 'og:title',
              property: 'og:title',
              content: `${type} ${title} ${salt}`
            },
            {
              hid: 'og:url',
              property: 'og:url',
              content: this.fullPath
            },
            {
              hid: 'og:tags',
              property: 'og:tags',
              content: 'смотреть онлайн, ' + title
            },
            {
              hid: 'og:inLanguage',
              name: 'og:inLanguage',
              content: 'ru_RU'
            },
            {
              hid: 'og:image',
              property: 'og:image',
              content: poster
            },
            {
              hid: 'og:image:thumbnailUrl',
              property: 'og:image:thumbnailUrl',
              content: poster
            },
            {
              hid: 'og:image:url',
              property: 'og:image:url',
              content: poster
            },
            {
              hid: 'og:image:secure_url',
              property: 'og:image:secure_url',
              content: poster
            }
          ]
        }
      }
    }
  },
  computed: {
    ...mapState(['user', 'isDesktop']),
    videoType() {
      if (this.video.type === 'anime-serial') {
        return { name: 'Аниме', type: 'anime-serial' }
      } else {
        return { name: 'Аниме фильм', type: 'anime' }
      }
    },
    videoPoster() {
      return this.filmPoster(this.video)
    }
  },
  // watch: {
  //   user() {
  //     if (this.user) this.checkFav()
  //   }
  // },
  async asyncData({ error, params, query, $axios }) {
    // console.log('/watch/_id', params, query)

    const id =
      params.id.includes('-')
        ? params.id.slice(0, params.id.indexOf('-'))
        : params.id
    const { data } = await $axios.get(`/api/watch?id=${id}`)

    // console.log('asyncData', data)

    // Object.freeze(data)
    if (data.error) {
      error(data.error)
    } else {
      let newStr = ''
      const str = data.film.title_ru
        .toLowerCase()
        .replace(/[^a-zа-я0-9]/g, ' ')
        .replace(/ {2,}/g, ' ')
      const c = {
        а: 'a',
        б: 'b',
        в: 'v',
        г: 'g',
        д: 'd',
        е: 'e',
        ё: 'jo',
        ж: 'zh',
        з: 'z',
        и: 'i',
        й: 'j',
        к: 'k',
        л: 'l',
        м: 'm',
        н: 'n',
        о: 'o',
        п: 'p',
        р: 'r',
        с: 's',
        т: 't',
        у: 'u',
        ф: 'f',
        х: 'h',
        ц: 'c',
        ч: 'ch',
        ш: 'sh',
        щ: 'shch',
        ъ: '',
        ы: 'y',
        ь: '',
        э: 'e',
        ю: 'ju',
        я: 'ja',
        ' ': '-',
        ';': '',
        ':': '',
        ',': '',
        '—': '-',
        '–': '-',
        '.': '',
        '«': '',
        '»': '',
        '"': '',
        "'": '',
        '@': ''
      }
      for (let i = 0; i < str.length; i++) {
        const ch = str.charAt(i)
        newStr += ch in c ? c[ch] : ch
      }
      newStr = newStr.replace(/-$/g, '')

      let se = null
      let eventTranslation = '0'
      let eventSeason = ''
      let eventEpisode = ''
      // const changeSEdata = null

      // console.log('data.film', data.film)

      if (Object.keys(query).length) {
        // const q = query.q
        se = {
          t: query.t ? query.t : '',
          s: query.s ? query.s : '',
          e: query.e ? query.e : '',
        }


        // se.s = q.indexOf('s') >= 0 ? q.slice(q.indexOf('s') + 1, q.indexOf('_e')) : ''
        // se.e = q.indexOf('e') >= 0 ? q.slice(q.indexOf('e') + 1) : ''

        // if (se.s) {
        //   se.t = q.slice(q.indexOf('t') + 1, q.indexOf('_s'))
        // } else if (q.includes('_')) {
        //   se.t = q.slice(q.indexOf('t') + 1, q.indexOf('_'))
        // } else {
        //   se.t = q.slice(q.indexOf('t') + 1)
        // }

        if (se.t) {
          const findII = data.vers.findIndex(el => +el.id === +se.t)
          if (findII >= 0) {
            if (se.s && se.e) {
              se.t = data.vers[findII].title
              eventTranslation = findII
              eventSeason = data.vers[findII].seasons[se.s] ? se.s : ''
              eventEpisode = eventSeason ?
                data.vers[findII].seasons[se.s].episodes[se.e]
                ? se.e
                : ''
              : ''
              if (eventSeason && eventEpisode) {
                const currentLink = data.vers[findII].seasons[eventSeason].episodes[eventEpisode]
                if (currentLink) {
                  data.film.iframe_url = currentLink
                }
              }
            } else if (se.t) {
              se.t = data.vers[findII].title
              eventTranslation = findII
            }
          }
        }
      } else if (!data.blocked) {
        const seasons = data.vers[eventTranslation].seasons ? data.vers[eventTranslation].seasons : null
        const season = (seasons && data.vers[eventTranslation].seasons)
          ? Object.keys(data.vers[eventTranslation].seasons)[0]
          : null
        const episodes = season ? data.vers[eventTranslation].seasons[season].episodes : null
        const episode = (episodes && data.vers[eventTranslation].seasons[season].episodes)
          ? Object.keys(data.vers[eventTranslation].seasons[season].episodes)[0]
          : null
        if (season && episode) {
          eventSeason = season
          eventEpisode = episode
          data.film.iframe_url = data.vers[eventTranslation].seasons[season].episodes[episode]
        } else if (data.vers[eventTranslation]) {
          data.film.iframe_url = data.vers[eventTranslation].link
        }
      }

      const vId = data.film.sh_id || data.film.wa_id || data.film.kinopoisk_id

      return {
        showComments: false,
        reactions: data.reactions,
        characters: data.characters || [],
        updates: data.updates || [],
        video: data.film || null,
        vers: data.vers || [],
        parts: data.parts,
        related: data.related,
        related_comics: data.related_comics,
        reviews: data.reviews,
        isBlock: data.blocked, // || !se,
        album_id: data.album_id,
        se,
        eventTranslation,
        // changeSEdata,
        eventSeason,
        eventEpisode,
        fullPath: data.film
          ? `${
            process.env.NODE_ENV === 'production'
              ? 'https://anime777.ru'
              : 'http://localhost:3004'
            }/watch/${vId}-${newStr}`
          : ''
      }
    }
  },
  data() {
    return {
      onVKPage: 1,
      showPremiumComponent: false,
      vkList: {
        count: 0,
        items: []
      },
      filmMenu: 'info',
      ratingNum: 0,
      animeggI: 0,
      yamusicI: 0,
      altNames: false,
      // characters: [],
      turnOff: false,
      showNotification: false,
      fav: null,
      favSeason: '00',
      favEpisode: '00',
      album: null,
      gets: {},
      loadVideo: false,
      charsInfo: {},
      charInfo: null,
      showVideos: false,
      showPhotos: false,
      ratingInterval: null,
      blockI: 0,
      rememberI: 0,
      amvText: ''
    }
  },
  mounted() {
    this.amvText = `аниме ${this.video.title_en} ${this.video.year}`
    if (this.video) {

      if (!this.characters.length) window.addEventListener('scroll', this.getAnimeGG)
      // window.addEventListener('scroll', this.getComments)
      // window.addEventListener('scroll', this.getShopItems)
      // window.addEventListener('scroll', this.getVideos)

      window.addEventListener
        ? window.addEventListener('message', this.kodikMessageListener)
        : window.attachEvent('onmessage', this.kodikMessageListener)

      // window.addEventListener('scroll', function(event) {
      //   const yamusic = document.querySelector('.yamusic')
      //   if (yamusic) {
      //     const visible = doc - yamusic.getBoundingClientRect().top
      //     // console.log('yamusic', visible)
      //     if (visible > 0 && !yamusicI) {
      //       ++yamusicI
      //       this.album = this.album_id
      //         ? `https://music.yandex.ru/iframe/#album/${this.album_id}`
      //         : ''
      //     }
      //   }
      // })

      // if (this.user) this.checkFav()

      const video = this.video.material_data ? this.video.material_data : null
      if (video && (video.imdb_rating || video.kinopoisk_rating)) {
        const ratingEl = document.querySelector('.rating-star-filled')
        const imdb = video.imdb_rating || 0
        const kp = video.kinopoisk_rating || 0
        const ratingCount = kp && imdb ? 2 : 1
        const rating = Math.floor(((kp + imdb) / ratingCount / 10) * 100)
        let ratingW = 0 //, ratingNum = (kp + imdb) / ratingCount / 2
        this.ratingInterval = setInterval(() => {
          if (ratingEl) ratingEl.style.width = ++ratingW + '%'
          // let r = this.ratingNum + (ratingNum / rating)
          // this.ratingNum = +r.toFixed(2)
          if (ratingW === rating) clearInterval(this.ratingInterval)
        }, 15)
      }
      // if (this.se) this.setIframe()
    }
  },
  beforeDestroy() {
    clearInterval(this.ratingInterval)
    window.removeEventListener('message', this.kodikMessageListener)
  },
  methods: {
    async onVK() {
      if (this.gets.onVK) return
      let title = this.video.title_ru

      if (this.se && this.se.s && this.se.e) {
        title += ` сезон ${this.se.s} серия ${this.se.e}`
      } else if (this.video.type === 'anime-serial') {
        title += ` сезон 1 серия 1`
      }

      const { data } = await this.$axios.get(`/api/on-vk?page=${
        this.onVKPage
      }&title=${encodeURIComponent(title)}`)
      if (data.error) {
        this.$store.commit('setError', { status: 'info', msg: data.error.message })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      } else if (this.onVKPage > 1) {
        const items = this.onVKPage > 1 ? this.vkList.items.concat(data.items) : data.items
        this.vkList.items = items
      } else {
        this.vkList = data
      }
      delete this.gets.onVK
    },
    urlToUpdate(video, update) {
      const transition = update.slice(update.indexOf('(') + 1, update.indexOf(')'))
      const findT = this.vers.find(el => el.title === transition.trim())
      const t = findT ? findT.id : null
      const season = update.match(/\d/g)[0]
      const episode = update.match(/\d/g)[1]

      const url = `/watch/${
        this.postUrl(video.sh_id || video.kinopoisk, video.title_ru)
      }?t=${
        t
      }&s=${
        season
      }&e=${
        episode
      }`

      return url
    },
    showTrailers() {
      this.filmMenu = 'videos'
      this.amvText = `аниме ${this.video.title_en} ${this.video.year} трейлер`
      this.showVideos = true
      this.$nextTick(() => {
        const elem = document.querySelector('.videos-block')
        if (elem) elem.scrollIntoView({ block: 'start', behavior: 'smooth' })
      })
    },
    goToComments() {
      // this.filmMenu = 'comments'
      this.$nextTick(() => {
        const elem = document.querySelector('.comments')
        if (elem) elem.scrollIntoView({ block: 'start', behavior: 'smooth' })
      })
    },
    kodikMessageListener(message) {
      if (
        !this.rememberI &&
        message.data.key === 'kodik_player_time_update' &&
        !(message.data.value % 300)
      ) {
        ++this.rememberI
        this.rememberSE(false)
      }

      if (
        message.data.key === 'kodik_player_time_update' && !(message.data.value % 60)
      ) {
        this.$axios.get(`/api/activity?task=watch`)
      }
    },
    switchSE(opt) {
      let eventEpisode = this.eventEpisode
      const episode = opt === '+' ? ++eventEpisode : --eventEpisode
      const elem = this.vers[this.eventTranslation].seasons[this.eventSeason].episodes[episode]
      if (elem) {
        this.eventEpisode = episode
        this.setSE()
      }
    },
    async rememberSE(showMsg = true) {
      if (!this.user) {
        if (showMsg) {
          this.$store.commit('setShowAuthForm', true)
          this.$store.commit('setError', { status: 'info', msg: 'Необходимо войти на сайт' })
          setTimeout(() => this.$store.commit('clearError'), 2000)
        }
        return
      }
      const id = this.video.sh_id || this.video.wa_id || this.video.kinopoisk_id
      let translator = null
      if ('' + this.eventTranslation) {
        translator = {
          id: this.vers[this.eventTranslation].id,
          title: this.vers[this.eventTranslation].title
        }
      }
      const obj = {
        user_id: this.user.id,
        date: Date.now(),
        type: 'anime',
        action: 'watching',
        translator,
        season: this.eventSeason ? this.eventSeason : null,
        episode: this.eventEpisode ? this.eventEpisode : null,
        title_ru: this.video.title_ru,
        id,
        poster: this.filmPoster(this.video)
      }

      const { data } = await this.$axios.post(`/api/user/favs`, obj)
      if (!data.error) {
        if (showMsg) {
          this.$store.commit('setError', { status: 'ok', msg: `Запомнили s${obj.season} e${obj.episode}` })
          setTimeout(() => this.$store.commit('clearError'), 1100)
        }
      }
    },
    changeTranslation() {
      if (this.vers[this.eventTranslation].seasons) {
        const season = Object.keys(this.vers[this.eventTranslation].seasons)[0]
        const episode = Object.keys(this.vers[this.eventTranslation].seasons[season].episodes)[0]
        if (season && episode) {
          this.eventSeason = season
          this.eventEpisode = episode
        }
      }
      this.setSE()
    },
    setSE() {
      let link = ''
      const obj = {}

      if (!(+this.eventTranslation >= 0)) {
        this.$store.commit('setError', 'Не выбран перевод')
        setTimeout(() => this.$store.commit('clearError'), 2000)
        return
      }

      obj.translation = this.vers[this.eventTranslation].title

      if (this.eventSeason && this.eventEpisode) {
        obj.season = this.eventSeason
        obj.episode = this.eventEpisode

        link = this.vers[this.eventTranslation].seasons[this.eventSeason].episodes[this.eventEpisode]

        document.title = `${this.video.title_ru}-s${obj.season}-e${obj.episode}-${obj.translation}`

        this.se = {
          s: obj.season,
          e: obj.episode,
          t: obj.translation
        }
      } else {
        link = this.vers[this.eventTranslation].link
      }

      link += '?hide_selectors=true'
      if (this.user && (this.user.group === 77 || this.user.group === 777 || this.user.group === 0)) link += `&uid=1JGDOR`

      obj.link = link
      // console.log('obj', obj)

      // this.changeSEdata = obj
      const iframe = document.querySelector('.iframe')
      if (iframe) {
        iframe.src = obj.link
        this.rememberI = 0
        // setTimeout(() => {
        //   iframe.contentWindow.postMessage({ key: "kodik_player_api", value: { method: "play" } }, '*')
        // }, 100)
      }

      this.vkList = {
        count: 0,
        items: []
      }
      this.onVKPage = 1
    },
    async getAnimeGG() {
      const doc = document.documentElement.clientHeight
      const animegg = document.querySelector('.animegg')
      if (animegg) {
        const visible = doc - animegg.getBoundingClientRect().top
        // console.log('animegg', visible)
        if (visible > 0 && !this.animeggI) {
          ++this.animeggI
          const { data } = await this.$axios.get(`/api/animegg?id=${this.video.sh_id.slice(2)}`)
          this.characters = data.chars.slice(0, 4)
        } else if(this.animeggI) {
          window.removeEventListener('scroll', this.getAnimeGG)
        }
      }
    },
    async getCharInfo(event, id, link) {
      // console.log('event', event.target)
      if (this.gets.getCharInfo) return
      if (this.charsInfo[id]) {
        this.charInfo = this.charsInfo[id]
      } else {
        // const loader = event.target.children[1].lastElementChild
        // if (loader) loader.style.display = 'inline-block'
        this.$store.commit('setError', { status: 'load', msg: 'Получаем информацию' })
        this.gets.getCharInfo = true
        const { data } = await this.$axios.post(`/api/charinfo`, { id, link })
        this.charInfo = data
        this.charsInfo[id] = data
        delete this.gets.getCharInfo
        // if (loader) loader.style.display = ''
        setTimeout(() => this.$store.commit('clearError'))
      }
    },
    async createCinema(id) {
      if (this.gets.createcinema) return
      this.gets.createcinema = true
      const body = {
        id,
        user_id: !this.user ? null : this.user.id,
        user_group: !this.user ? null : this.user.group,
        hidden: !this.user
      }
      this.$store.commit('setError', { status: 'load', msg: 'Идет создание комнаты' })
      const { data } = await this.$axios.post(`/api/cinema`, body)
      // console.log(data)
      if (data.error) {
        this.$store.commit('setError', { status: 'warn', msg: data.error })
        setTimeout(() => this.$store.commit('clearError'), 3000)
      } else {
        this.$store.commit('setError', { status: 'ok', msg: data.msg })
        setTimeout(() => {
          this.$store.commit('clearError')
          this.$router.push(`/cinema/${data.body._id}`)
        }, 1000)
      }
    },
    goShare(url) {
      window.open(url)
    },
    async checkFav() {
      if (this.user) {
        const { data } = await this.$axios.get(`/api/user/favs`)
        if (!data.anime.length) return
        data.anime.forEach(fav => {
          if (
            fav.id === this.video.sh_id ||
            fav.id === this.video.wa_id ||
            fav.id === this.video.kinopoisk_id
          ) {
            const favElem = document.querySelector(`span[data-fav-id="${fav.id}"]`)
            if (favElem) favElem.classList.add('dfav')
          }
        })
      }
    },
    showMinimize(video) {
      if (this.$refs.iframe.src) {
        const obj = {
          title_ru: this.video.title_ru,
          kinopoisk_id: this.video.kinopoisk_id,
          src: this.$refs.iframe.src
        }
        this.$store.commit('minimizeVideo', obj)
      } else {
        this.$store.commit('setError', 'Начните просмотр')
        setTimeout(() => this.$store.commit('clearError'), 2000)
      }
    },
    setIframeVK(src) {
      // if (!this.user) {
      //   this.$store.commit('setError', { status: 'info', msg: 'Необходимо войти на сайт' })
      //   setTimeout(() => this.$store.commit('clearError'), 2000)
      // } else if (
      //   this.user.group === 77 ||
      //   this.user.group === 777
      // ) {
        this.$refs.iframe.src = src
        this.loadVideo = true
        const elem = document.querySelector('.film-meta h1')
        if (elem) elem.scrollIntoView({ block: 'start', behavior: 'smooth' })
      // } else {
      //   this.$store.commit('setError', { status: 'info', msg: 'Доступно для Premium' })
      //   setTimeout(() => this.$store.commit('clearError'), 2000)
      //   this.showPremiumComponent = true
      // }
    },
    setIframe() {
      let link = this.isBlock
        ? this.video.iframe_url + `?geoblock=RU,UA`
        : this.video.iframe_url + '?hide_selectors=true'

      if (this.user && (this.user.group === 77 || this.user.group === 777 || this.user.group === 0)) link += `&uid=1JGDOR`
      this.$refs.iframe.src = link
      this.loadVideo = true

      if (this.user) {
        const obj = {
          date: Date.now(),
          type: 'anime',
          user_id: this.user.id,
          title_ru: this.video.title_ru,
          id: this.video.sh_id || this.video.wa_id || this.video.kinopoisk_id,
          poster: this.videoPoster
        }
        this.$axios.post(`/api/user/history`, obj)
      }
    }
  }
}
</script>

<style src="~/assets/watch.styl" lang="stylus">
